import NextErrorComponent from 'next/error';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const CustomErrorComponent = (props)=>_jsx(NextErrorComponent, {
        statusCode: props.statusCode
    });
CustomErrorComponent.getInitialProps = async (contextData)=>NextErrorComponent.getInitialProps(contextData);
export default CustomErrorComponent;
